<template>
	<div>
		<!-- begin #page-container -->
		<head>
			<link rel="stylesheet" href="../../static/css/style.min.css" />
		</head>

		<div id="page-container" class="">
			<!-- begin login -->
			<div class="login login-with-news-feed">
				<!-- begin news-feed -->
				<div class="news-feed">
					<div class="news-image">
						<img
							src="../../static/img/bg_vca.png"
							data-id="login-cover-image"
							alt=""
						/>
					</div>
					<div class="news-caption">
						<h4 class="caption-title">
							<i class="ion-asterisk m-r-15 fa-2x pull-left"></i>
							Central de Marcação de Consultas
						</h4>
						<p></p>
					</div>
				</div>
				<!-- end news-feed -->
				<!-- begin right-content -->
				<div class="right-content">
					<!-- begin login-header -->
					<div class="login-header">
						<!-- <h3 class="text-center text-bold text-danger">VERSÃO DE TESTES</h3> -->
						<div class="brand">
							<img
								class="logo-protocolo"
								src="../../static/img/MARCA 1.png"
							/>
							<!--<span class="logo"><i class="ion-asterisk"></i></span> Protocolo
                                <small>Gerenciador de protocolos e documentos</small>-->
						</div>
						<!--<div class="icon">
                        <i class="ion-ios-locked"></i>
                        </div>-->
					</div>
					<!-- end login-header -->

					<!-- begin login-content -->
					<div class="login-content">
						<form @submit.prevent="onSubmitLogin">
							<flash-message
								style="margin-bottom: 5px"
								transitionIn="animated swing"
							></flash-message>
							<div class="form-group m-b-15">
								<input
									type="text"
									class="form-control input-lg"
									v-model="username"
									placeholder="Usuário"
									required
									ref="username"
								/>
							</div>
							<div class="form-group m-b-15">
								<input
									type="password"
									class="form-control input-lg"
									v-model="password"
									placeholder="Senha"
									required
								/>
							</div>
							<div class="login-buttons">
								<button
									type="submit"
									class="btn btn-primary btn-block btn-lg"
									:disabled="finalizado"
								>
									Entrar
								</button>
							</div>
							<div class="m-t-20 m-b-40 p-b-40 text-inverse">
								Esqueci minha
								<a
									href="#"
									data-toggle="modal"
									data-target="#modal-recuperar-senha"
									>senha.</a
								>
							</div>
							<hr />
							<p class="text-center">&copy; PMVC - 2018</p>
						</form>
					</div>
					<!-- end login-content -->
				</div>
				<!-- end right-container -->
			</div>
			<!-- end login -->
		</div>
		<!-- end page container -->
	</div>
</template>

<script>
import axios from "axios";
import VueRecaptcha from "vue-recaptcha";

export default {
	components: { VueRecaptcha },
	name: "Login",
	data(router) {
		return {
			finalizado: false,
			section: "Login",
			loading: "",
			username: "",
			password: "",
			response: "",
			captchaResponse: "",
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.$refs.username.focus();
		});
	},
	methods: {
		onSubmitLogin() {
			this.finalizado = true;
			const { username, password } = this;
			this.toggleLoading();
			this.resetResponse();
			this.$store.commit("TOGGLE_LOADING");

			/* Fazendo chamada a API para Autenticar */
			axios
				.post(
					`${this.$store.state.serverURI}/api/login`,
					{
						username,
						password,
					},
					this.$store.getters.getHeader
				)
				.then((response) => {
					this.toggleLoading();
					if (response.status === 401) {
						this.flash("Usuário ou senha inválidos", "error", {
							timeout: 10000,
						});
						return;
					}

					var data = response.data;

					if (data.access_token) {
						var token = data.access_token;
						this.$store.commit(
							"SET_TOKEN",
							token
						); /* Setando o token no estado do vuex (store) */

						/* Buscando dados do usuário através do token recuperado */
						axios
							.get(
								`${this.$store.state.serverURI}/api/usuario/getUserCurrent`,
								this.$store.getters.getHeaderAuth
							)
							.then((resp) => {
								var userCurrent = resp.data;
								this.setUsuarioAtual(userCurrent);
								if (window.localStorage) {
									window.localStorage.setItem("token", token);
								}
							})
							.then((a) => {
								let route = "/";
								if (
									localStorage.getItem("route") &&
									localStorage.getItem("route") != "undefined"
								) {
									let path = localStorage
										.getItem("route")
										.split("/", 3);
									route = path.join("/");
									if (!route) {
										route = "/";
									}
								}
								localStorage.removeItem("route");
								console.log(route);
								window.sessionStorage.setItem("logeed", true);
								this.$router.push(
									data.redirect ? data.redirect : route
								);
							})
							.catch((error) => {
								console.log(error);
							});
					}
				})
				.catch((error) => {
					this.finalizado = false;
					if (error.response.status === 401) {
						if (
							error.response.data.message &&
							!error.response.data.message.includes(
								"Unauthenticated"
							)
						) {
							this.flash(error.response.data.message, "error", {
								timeout: 10000,
							});
						} else {
							this.flash("Usuário ou senha inválidos", "error", {
								timeout: 10000,
							});
						}
						return;
					}
					if (error.response.status === 403) {
						this.flash("Captcha inválido", "error", {
							timeout: 10000,
						});
						return;
					}
					this.$store.commit("TOGGLE_LOADING");
					console.log(error);

					this.response = "Ocorreu uma falha na autenticação!";
					this.toggleLoading();
				});
		},
		verify(response) {
			this.captchaResponse = response;
		},
		toggleLoading() {
			this.loading = this.loading === "" ? "loading" : "";
		},
		resetResponse() {
			this.response = "";
		},
		recaptcha() {
			this.$recaptcha("login").then((token) => {
				console.log(token); // Will print the token
			});
		},
	},
};
</script>

<style scoped>
input,
select {
	text-transform: none !important;
}

.right-content {
	background-color: white;
	height: 100vh !important;
}

.logo-protocolo {
	width: 380px;
}

.ajuste-margin {
	margin: 20px 0;
}

@media only screen and (max-device-width: 728px) {
	.logo-protocolo {
		width: 648px;
	}
}

@media only screen and (max-device-width: 414px) {
	.logo-protocolo {
		width: 334px;
	}
}

@media only screen and (max-device-width: 400px) {
	.logo-protocolo {
		width: 320px;
	}
}

@media only screen and (max-device-width: 375px) {
	.logo-protocolo {
		width: 295px;
	}
}
</style>



// WEBPACK FOOTER //
// Login.vue?341492c2